export default [
  {
    text: "Recommending Approval",
    value: "Recommending Approval"
  },
  {
    text: "Noted By",
    value: "Noted By"
  },
  {
    text: "Approved By",
    value: "Approved By"
  }
];
